import {ChipList} from '@ui/forms/input-field/chip-field/chip-list';
import {Chip} from '@ui/forms/input-field/chip-field/chip';
import {Trans} from '@ui/i18n/trans';
import React from 'react';

export function EnumLinkStatusChip({status}: {status: number}) {
  return (
    <ChipList
      radius="rounded"
      color={status === 1 ? 'positive' : status === 2 ? 'danger' : 'chip'}
      size="xs"
    >
      <Chip key={status} selectable>
        <Trans message={EnumLinkStatus({value: status})} />
      </Chip>
    </ChipList>
  );
}

export function EnumLinkStatus({value}: {value: number}): string {
  return value === 1 ? 'Active' : value === 2 ? 'Dead' : 'Pending';
}
